import {
    Coordinate2d,
    SimpleReelModel,
    SimpleReelModelDelegate,
    SimpleReelModelState,
    SimpleReelModelSymbolData,
    SimpleSymbolState
} from "./SimpleReelModel";

import {gsap} from "gsap";
import {GSAPUtils} from "../../../game/utils/GSAPUtils";
import {KitchenDramaSushiManiaStatics} from "../../../game/utils/KitchenDramaSushiManiaStatics";

/**
 * Created by jonas on 2022-06-10.
 */




export class SimpleAvalancheReelModel extends SimpleReelModel {



    private _symbols:SimpleReelModelSymbolData[];
    private _symbolPositions:Coordinate2d[];
    private _startPosition:Coordinate2d;
    private _endPosition:Coordinate2d;
    private _dropOutSymbols:SimpleReelModelSymbolData[];
    private _startYOffset:number = 0;
    private _endYOffset:number = 0;

    constructor(id:number, delegate:SimpleReelModelDelegate, triggerEvents:boolean = false) {
        super(id, delegate, triggerEvents);
        this._symbols = [];
    }

    public setStartAndEndPositions(start:Coordinate2d, end:Coordinate2d) {
        this._startPosition = start;
        this._endPosition = end;
        this.updateOffsets();
    }

    private updateOffsets(){
        if (this._startPosition && this._symbolPositions) {
            this._startYOffset = this._startPosition.y - this._symbolPositions[this._symbolPositions.length-1].y;
            this._endYOffset = this._endPosition.y - this._symbolPositions[0].y;
        }
    }

    public init(symbolNames:string[], symbolPositions:Coordinate2d[]) {
        this.clearSymbols(this._symbols);

        this._symbolPositions = symbolPositions;
        this.updateOffsets();
        for (let i:number = 0; i < symbolNames.length; i++){
            const symbol = this.createNewSymbol(symbolNames[i], i, SimpleReelModelState.IDLE)
            symbol.positionable.setSymbolState(SimpleSymbolState.NORMAL)
            symbol.positionable.position.x = this._symbolPositions[i].x;
            symbol.positionable.position.y = this._symbolPositions[i].y;
            this._symbols.push(symbol);
        }
    }

    public dropIn(symbolNames:string[]) {
        const dropAnimations = [];
        for (let i:number = 0; i < symbolNames.length; i++){
            const symbol = this.createNewSymbol(symbolNames[i], i, SimpleReelModelState.IDLE)
            symbol.positionable.setSymbolState(SimpleSymbolState.NORMAL);
            symbol.positionable.position.x = this._symbolPositions[i].x;
            symbol.positionable.position.y = this._symbolPositions[i].y + this._startYOffset;
            this._symbols.push(symbol);

            const tl = gsap.timeline();
            tl.add(()=>{
                symbol.positionable.setSymbolState(SimpleSymbolState.DROP_IN);
            })
            tl.add(gsap.to(symbol.positionable.position, {
                duration:0.2,
                x:this._symbolPositions[i].x,
                y:this._symbolPositions[i].y,
                ease:"power1.in"
            }));

            dropAnimations.push(tl);

        }

        const tl =  GSAPUtils.createTimelineFromArray(dropAnimations.reverse(), "<0.1");
        tl.timeScale(KitchenDramaSushiManiaStatics.TIME_SCALE);
        return tl;

    }

    public dropOut():gsap.core.Timeline {
        this._dropOutSymbols = this._symbols.concat();
        this._symbols = [];

        const dropAnimations = [];
        for (let i:number = 0; i < this._dropOutSymbols.length; i++){
            const symbol = this._dropOutSymbols[i];
            const tl = gsap.timeline();
            tl.add(()=>{
                symbol.positionable.setSymbolState(SimpleSymbolState.DROP_OUT);
            })
            tl.add(gsap.to(symbol.positionable.position, {
                duration:0.25,
                x:this._symbolPositions[i].x,
                y:this._symbolPositions[i].y + this._endYOffset,
                ease:"power1.in"
            }),1.0);

            dropAnimations.push(tl);
        }

        const tl = gsap.timeline({onComplete:()=>{
            this.clearSymbols(this._dropOutSymbols);
        }});
        tl.add(GSAPUtils.createTimelineFromArray(dropAnimations.reverse(), "<0.1"));

        tl.timeScale(KitchenDramaSushiManiaStatics.TIME_SCALE);
        tl.add(gsap.to(this,{duration:0.0001}));


        return tl;
    }

    public collapseAndFill(symbolNames:string[]):gsap.core.Timeline {
        let popped:SimpleReelModelSymbolData[] = [];

        for (let i:number = this._symbols.length-1; i >= 0; i--){
            const symbol = this._symbols[i];
            if (symbol.removed){
                const spliced = this._symbols.splice(i,1);
                popped.unshift(spliced[0]);
            }
        }


        for (let i:number = popped.length-1; i >= 0; i--){
            const symbol = this.createNewSymbol(symbolNames[i], -1, SimpleReelModelState.FILL_UP)
            symbol.positionable.position.x = this._symbolPositions[i].x;
            symbol.positionable.position.y = this._symbolPositions[i].y + this._startYOffset;

            this._symbols.unshift(symbol);
        }

        const dropAnimations = [];
        for (let i:number = 0; i <  this._symbols.length; i++) {
            const symbol = this._symbols[i];
            if (symbol.reelPosition == i){
                continue;
            }
            symbol.reelPosition = i;

            const tl = gsap.timeline();
            tl.add(()=>{
                symbol.positionable.setSymbolState(SimpleSymbolState.COLLAPSE);
            })
            tl.add(gsap.to(symbol.positionable.position, {
                duration:0.15,
                x:this._symbolPositions[i].x,
                y:this._symbolPositions[i].y,
                ease:"power1.in"
            }),0.4);

            dropAnimations.push(tl);

        }

        const tl = GSAPUtils.createTimelineFromArray(dropAnimations.reverse(), "<0.1");
        tl.add(()=>{
            this.clearSymbols(popped);
        })
        return tl;
    }


    public swapSymbol(newName:string, position:number):{oldSymbol:SimpleReelModelSymbolData, newSymbol:SimpleReelModelSymbolData}{
        const oldSymbol = this._symbols[position]
        const newSymbol:SimpleReelModelSymbolData = this.createNewSymbol(newName, oldSymbol.reelPosition, SimpleReelModelState.IDLE);
        newSymbol.positionable.position.x = oldSymbol.positionable.position.x;
        newSymbol.positionable.position.y = oldSymbol.positionable.position.y;

        this._symbols[position] = newSymbol;

        return {
            oldSymbol:oldSymbol,
            newSymbol:newSymbol
        };
    }


    getAllVisibleSymbols():SimpleReelModelSymbolData[] {
        return this._symbols;
    }

    removeSymbolAt(row:number) {
        return undefined;
    }
}